import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import AccountSwitch from './AccountSwitch';
import { userActions, accountsSel } from 'src/store/modules/user';
import {
  signInActions,
  activeAccountSel,
  accountHasChangedSel
} from 'src/store/modules/signin';

const mapStateToProps = (state: any) => {
  return {
    activeAccount: activeAccountSel(state),
    accounts: accountsSel(state),
    accountHasChanged: accountHasChangedSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): any => ({
  getAccounts: () => dispatch(userActions.getUserAccounts()),
  changeActiveAccount: (newAccountId: string, clientIdentity: string) =>
    dispatch(signInActions.changeActiveAccount(newAccountId, clientIdentity)),
  changeActiveAccountFlag: (flag: boolean) =>
    dispatch(signInActions.activeAccountHasChanged(flag))
});

export const pureComponent = AccountSwitch;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(withRouter(AccountSwitch)));
